import axios from "axios";

// axios.defaults.baseURL = 'http://192.168.2.12:80/mirror';

axios.defaults.baseURL = 'http://192.168.2.11:8083/mirror';

axios.defaults.withCredentials = true;

/**
 * slideList  轮播图
 * classList  分类
 * bookList  书籍
 * searchList  搜索
 * bookDetail  书籍详情
 * bookClick  增加书籍点击量
 * bookPlay    增加书籍播放量
 * addCollect  添加书籍收藏
 * deleteCollect   删除书籍收藏
 * collectList   收藏列表
 * addHistory    添加书籍历史
 * deleteHistory   删除书籍历史
 * historyList   历史列表
 * chapterList  章节
 * login      登录
 * logout     退出
 * register     注册
 * changePwd     修改密码
 * resetPwd   重置密码
 * audienceList  搜索用户列表
 * bottomInfo  底部信息
 * statisticsList 统计信息
 */
const allApi = {
    slideList: (data) => { return axios.get("/carousel/all") },

    classList: (data) => { return axios.get("/clazz/all") },

    bookList: (data) => { return axios.get("/book/page/" + data.page + "/" + data.size + "/" + data.clazz) },

    searchList: (data) => { return axios.get("/book/search/" + data.page + "/" + data.size, {params: data.search}) },

    bookDetail: (data) => { return axios.get("/book/detail/" + data.book) },

    bookClick: (data) => { return axios.put("/book/click/" + data.book) },

    bookPlay: (data) => { return axios.put("/book/play/" + data.book) },

    addCollect: (data) => { return axios.post("/authorized/collect/add/" + data.book) },

    deleteCollect: (data) => { return axios.delete("/authorized/collect/delete/" + data.id + "/" + data.book) },

    collectList: (data) => { return axios.get("/authorized/collect/page/" + data.page + "/" + data.size) },

    addHistory: (data) => { return axios.post("/authorized/history/save/" + data.book, data.data) },

    deleteHistory: (data) => { return axios.delete("/authorized/history/delete/" + data.id) },

    historyList: (data) => { return axios.get("/authorized/history/page/" + data.page + "/" + data.size) },

    chapterList: (data) => { return axios.get("/chapter/page/" + data.page + "/" + data.size + "/" + data.book + "/" + data.history) },

    login: (data) => { return axios.post("/auth/login", data) },

    logout: (data) => { return axios.get("/auth/logout") },

    register: (data) => { return axios.post("/audience/register", data) },

    changePwd: (data) => { return axios.put("/authorized/password/update", data) },

    resetPwd: (data) => { return axios.put("/authorized/password/reset", data) },

    bottomInfo: (data) => { return axios.get("/auth/info") },

    statisticsList: (data) => { return axios.get("/authorized/statistics/page/" + data.page + "/" + data.size, {params: data.date}) },

    statisticsCount: (data) => { return axios.get("/authorized/statistics/count", {params: data.date}) },

    classBooksPage: (data) => { return axios.get("/authorized/class/books/page/" + data.page + "/" + data.size, {params: data.search}) },

    classBooksCount: (data) => { return axios.get("/authorized/class/books/count", {params: data.search}) },

    audienceList: (data) => { return axios.get("/authorized/audience/page/" + data.page + "/" + data.size, {params: data.search}) },
}
export default allApi;